import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationCS from './locales/cs/translation.json';
import translationES from './locales/es/translation.json';
import translationRU from './locales/ru/translation.json';
import translationFR from './locales/fr/translation.json';
import translationIT from './locales/it/translation.json';
import translationPT from './locales/pt/translation.json';
import translationPL from './locales/pl/translation.json';
import translationKO from './locales/ko/translation.json';
import translationZH from './locales/zh/translation.json';
import translationNL from './locales/nl/translation.json';
import translationHU from './locales/hu/translation.json';
import translationRO from './locales/ro/translation.json';
import translationHE from './locales/he/translation.json';
import translationJP from './locales/jp/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  },
  cs: {
    translation: translationCS
  },
  es: {
    translation: translationES
  },
  ru: {
    translation: translationRU
  },
  fr: {
    translation: translationFR
  },
  it: {
    translation: translationIT
  },
  pt: {
    translation: translationPT
  },
  pl: {
    translation: translationPL
  },
  ko: {
    translation: translationKO
  },
  zh: {
    translation: translationZH
  },
  nl: {
    translation: translationNL
  },
  hu: {
    translation: translationHU
  },
  ro: {
    translation: translationRO
  },
  he: {
    translation: translationHE
  },
  jp: {
    translation: translationJP
  },
  ar: {
    translation: translationAR
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
